import { ADMIN_PREVIEW_KEY } from '../constants';

const AUTH_TOKENS_KEY = 'auth_meta';

type PreviewMode = 'user' | 'admin';

export const isAdminSession = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem(AUTH_TOKENS_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Boolean(parsed?.is_admin);
  } catch (err) {
    console.warn('admin preview localStorage blocked', err);
    return false;
  }
};

export const setPreviewMode = (mode: PreviewMode) => {
  if (typeof window === 'undefined') return;
  try {
    if (mode === 'user') {
      window.sessionStorage.setItem(ADMIN_PREVIEW_KEY, 'user');
    } else {
      window.sessionStorage.removeItem(ADMIN_PREVIEW_KEY);
    }
  } catch (err) {
    console.warn('admin preview sessionStorage blocked', err);
  }
};

export const isUserPreviewActive = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(ADMIN_PREVIEW_KEY) === 'user';
};
